import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import "./Profile.scss";
import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import Button from "react-bootstrap/Button";
import ProfileComponent from "../../components/Profile/ProfileComponent";
import {Badge} from "react-bootstrap";

function TicketsUser() {
    const [page, setPage] = useState(0);
    const [list, setList] = useState([]);

    useEffect(() => {
        let data = {page: page + 1};
        fetch(global.route.userListTicket, {
            method: "post",
            credentials: 'include',
            body: global.getFormData(data)
        }).then((response) => {
            if (!response.ok) {
                global.catchError(response);
            }
            return response.json();
        })
            .then(response => {
                console.log(response);
                setList([...response.list, ...list]);
                console.log("list");
                console.log(list);
                setPage(response.paginator.page);
            }).catch((error) => {
            if (typeof error !== "undefined")
                global.catchError(error);
        });

    }, []);

    let renderTickets = () => {
        let result = [];
        for (let ticket of list) {
            console.log("ticket");
            console.log(ticket);
            let type_payment = "Pagato in contanti";
            if(ticket.type_payment === "PAYMENT_PAYPAL")
            type_payment = "Pagato con PayPal";
            if(ticket.type_payment === "PAYMENT_STRIPE")
                type_payment = "Pagato con carta";
            result.push(<div className={"card cart-ticket mb-4"}>
                <div className="card-header">
                    <b>{ticket.ticket.name}</b>
                </div>
                <div className="card-body d-flex flex-column">
                    <span>Nominativo: {ticket.nickname}</span>
                    <span><b>Totale: {ticket.price.toFixed(2)}€</b></span>
                    <span>Acquistato il {ticket.date_purchase}</span>
                    <span>{type_payment}</span>
                    <div className={"d-flex gap-2 mb-2 mt-2"}>
                        <Badge bg={"dark"}>Attivo dal {ticket.date_start_use}</Badge>
                        <Badge bg={"dark"}>Attivo fino al {ticket.date_end_use}</Badge>
                    </div>
                    <Button className={"btn-orange mb-2"}>Scarica il permesso/ticket in PDF</Button>
                    <Button variant={"success"}>Acquista di nuovo</Button>
                </div>
            </div>);
        }
        return result;
    }

    return (
        <div>
            <Header/>
            <div className="container container-profile" style={{paddingTop: 86, minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <ProfileComponent/>
                    </div>
                    <div className="col-md-8 mb-4">
                        {renderTickets()}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default TicketsUser;